 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		384: 0,
 		280: 0,
 		281: 0,
 		285: 0,
 		287: 0,
 		289: 0,
 		290: 0,
 		291: 0,
 		339: 0,
 		340: 0,
 		347: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","217":"AddClosedAlertIDUseCase","218":"CreateDeviceUseCase","219":"CreateDomestikaFollowUseCase","220":"CreateJWTUserUseCase","221":"CreateUserLiveSessionUseCase","222":"CurrentUserUseCase","223":"CurrentWithoutRelationshipsUserUseCase","224":"DeleteDeviceUseCase","225":"DeleteFollowUseCase","226":"ENV_CONFIG1","227":"ENV_CONFIG4","228":"ENV_CONFIG5","229":"ENV_CONFIG6","230":"ENV_CONFIG7","231":"FinishUserLiveSessionUseCase","232":"GetAccessTokenUserUseCase","233":"GetAdvanceGDPRStatusUserUseCase","234":"GetAllBlogUseCase","235":"GetAreasCourseUseCase","236":"GetCartCourseUseCase","237":"GetCategoriesCourseUseCase","238":"GetCourseUseCase","239":"GetFinalProjectVideoByCourseIDCourseUseCase","240":"GetGDPRStatusUserUseCase","241":"GetListLiveFeedbackQuestionUseCase","242":"GetListLiveSessionUseCase","243":"GetListLiveStreamUseCase","244":"GetLiveChannelUseCase","245":"GetLiveSessionUseCase","246":"GetOrganizationUseCase","247":"GetPlusPromotionUseCase","248":"GetPostContentBlogUseCase","249":"GetPromotionCodeAlertUseCase","250":"GetPromotionUseCase","251":"GetPubnubCredentialsUseCase","252":"GetSessionDataUserUseCase","253":"GetSimpleUserUseCase","254":"GetSoftwaresCourseUseCase","255":"GetUserAlertUseCase","256":"GetVideoProgressListCourseUseCase","257":"GetVideoSpeedUserUseCase","258":"GetVideoVolumeUserUseCase","259":"LogoutUserUseCase","260":"PathToRegexp","261":"RefreshAccessTokenUserUseCase","262":"RemoveAccessTokenUserUseCase","263":"SearchCourseUseCase","264":"SendHeaderTrackingUseCase","265":"SendLiveFeedbackAnswersUseCase","266":"SendPlayerTrackingUseCase","267":"SendTrackingUseCase","268":"SendVideoProgressCourseUseCase","269":"SetAdvanceGDPRStatusUserUseCase","270":"SetGDPRStatusUserUseCase","271":"SetVideoSpeedUserUseCase","272":"SetVideoVolumeUserUseCase","273":"UpdateLanguageUserUseCase","274":"UpdateLiveSessionUseCase","275":"UpdateVideoAudioAndSubtitlesCourseUseCase","276":"UpdateVideoProgressCourseUseCase","277":"ViewPageTrackingUseCase","348":"vendors~AddClosedAlertIDUseCase","349":"vendors~AmplitudeJS","350":"vendors~SearchCourseUseCase","351":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"0dd59a71b39c14619074","1":"d024d6e622c8d15c60db","2":"ff65ea44a6dcfc51051d","3":"214ae77705e1a2ce4243","4":"accbe76947d14647bd7f","5":"19f435ba1f05370cd5d8","6":"82e27fb3dd793b2ea56e","216":"a5be16d5f80ac979f904","217":"f42adb11c288bb4baea9","218":"896cb9cef336dc45c547","219":"df877dc2ddf78462e051","220":"f680ec83bec274ce29dd","221":"7df02b2ed9e0c6787c81","222":"b6c189307237c3761fa8","223":"596503cd7cf121748538","224":"c774437a8486bbd0ec72","225":"b8aeb104837e1038a640","226":"f1c43e61a9cd6af4b62a","227":"7c5637ffa7ad5e2d4a61","228":"414384cfa4cf5a7a449a","229":"6b8c2e96facae9eda6fe","230":"beda36b5457f95a3cbbd","231":"cdd4d106fa89fccade32","232":"5536729af05d0c25dea0","233":"4cf855683fb083f35022","234":"49f96518769645a55427","235":"d6da38fdd28d706d6b8c","236":"4f4dffea831c82d253f9","237":"1fe64ed1bdf649368ce9","238":"511fecad2b9301ef5ffe","239":"1cafcc9719625f7a96c3","240":"249dc706daf86489d549","241":"7df74041db8b46ba65c4","242":"9f8046cf2394e013625b","243":"192996d217c890c32b40","244":"43e8d1c87e5898a33090","245":"9e97d631d84ca6d6f55a","246":"f4173c152ae1ddc68e34","247":"5cbbb87f976b39258746","248":"5bcaa1c61ecd2c052a95","249":"ef5ce52c34abd756e70e","250":"fc81c943df6f19163321","251":"80e490f1967c1cdd2cb9","252":"83928cc9eed03b5a4ba7","253":"20f775e4aa03a89bee90","254":"8f9ff0989fd99966bbe3","255":"d02ecf5662e1774aea0a","256":"b31c3d488cd9540a19d7","257":"e99e1190cfacbb410e48","258":"930fb7d0917ddfb2391a","259":"10df385fdcf02caee6db","260":"d8750348505f1aa4ad61","261":"5dd3adfc6a753fa354f2","262":"b7b89f8fd1a4b7392d49","263":"b1c8aea036d2906d7ede","264":"c88297ef3a5ed25be149","265":"5682f5bab97ce8e33deb","266":"d0230f06690b206e2f7c","267":"f01ee4b6bfb2f9a9af94","268":"c4c712aba5e919f302f6","269":"83a48a63de5ec7ee59cf","270":"d8b4223b4659b6611a93","271":"5afb4e7542112eb9b3b9","272":"582719e6ae9388e425ec","273":"d45c487de1e9af063ae8","274":"86e9016ffcfbb5f546a1","275":"7befe79559bb0b9c231e","276":"85c6ba2d09a6d71cbc48","277":"90aa892dddd5ed728e02","348":"6bef404f2be923365f98","349":"0f8ef40557283d6be8d0","350":"d1adfb1c99b48a344fd1","351":"dcb4a07ce570c698a3aa","419":"1839e0d0c7a70ad7682f","421":"1747b9f36e5271281785","422":"0d6ff0ea154f3dfeb40a","640":"e7bf9c88b3bc4b412ba0","641":"d16c6665bfba7d8e02a3","642":"d9d385dc1d69aa1b3324"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2174);
